import { Box, Button, Grid } from '@mui/material'
import { backgroundColors } from '../../Components/Common/Color/Color'
import TaskTable from '../../Components/Report/TaskReport/TaskTable'
import { useEffect, useRef } from 'react'
import { selectSearchQuery } from '../../redux/task/manageTasks/selector'
import { setSearchQuery, resetFilters } from '../../redux/task/manageTasks/slice'
import { useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchTaskDetailsReport } from '../../redux/reports/task/action'
import { fetchTasks } from '../../redux/task/manageTasks/actions'
import TaskReportChart from '../../Components/Report/TaskReport/Chart/TaskReportChart'
import RefreshIcon from '@mui/icons-material/Refresh'
import TaskFilter from '../../Components/Task/TaskFilter'
import SearchInput from '../../Components/Common/SearchInput'
import { fetchTeamMembers } from '../../redux/teamMember/actions'

const TaskReportPage = () => {
  const dispatch = useAppDispatch()
  const searchQuery = useAppSelector(selectSearchQuery)
  // Set to true when navigating to a task detail page (View Details button)
  // so the cleanup effect does NOT reset the filters on unmount.
  const navigatingToDetailsRef = useRef(false)

  const fetchData = async () => {
    await dispatch(fetchTasks()).unwrap()
    await dispatch(fetchTaskDetailsReport())
    await dispatch(fetchTeamMembers())
  }

  useEffect(() => {
    fetchData()
    return () => {
      if (!navigatingToDetailsRef.current) {
        dispatch(resetFilters())
      }
    }
  }, [dispatch])

  const handleRefreshData = async () => {
    await fetchData()
  }

  const handleSearchChange = (query: string) => {
    dispatch(setSearchQuery(query))
  }

  const handleClearSearch = () => {
    dispatch(setSearchQuery(''))
  }

  return (
    <Box
      component='div'
      sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
      borderRadius={2}
      boxShadow={1}
    >
      <Box sx={{ p: 2 }}>
        <TaskReportChart />
      </Box>
      <Grid container sx={{ p: 2 }} flexDirection='row' alignItems={'center'} justifyContent='end'>
        <Grid>
          <Grid container spacing={2} alignItems='center' display='flex'>
            <Grid>
              <Button
                id='refresh-button'
                color='success'
                startIcon={<RefreshIcon />}
                onClick={handleRefreshData}
              >
                Refresh
              </Button>
            </Grid>

            <Grid>
              <TaskFilter />
            </Grid>
            <Grid>
              <SearchInput
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                onClearSearch={handleClearSearch}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box>
        <TaskTable onViewDetails={() => { navigatingToDetailsRef.current = true }} />
      </Box>
    </Box>
  )
}

export default TaskReportPage
